import TextInput from "components/inputs/text-input";
import ModalTemplate from "components/modal/modal-template";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import DragNDrop from "components/inputs/dragNdrop";

interface IProps {
  close: () => void;
  save: (link: { url: string; name: string; audio: File }) => void;
  editData?: { url: string; name: string; audio: File };
  saveEdit?: (link: { url: string; name: string; audio: File }) => void;
}
const EmbedAudioModal = ({ close, save, editData, saveEdit }: IProps) => {
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [audio, setAudio] = useState<File>();

  const disableConfirm = useMemo(() => {
    if (name.length === 0 || !audio) {
      return true;
    }
    return false;
  }, [name, audio]);

  useEffect(() => {
    if (editData) {
      setName(editData.name);
      setUrl(editData.url);
      setAudio(editData.audio);
    }
  }, [editData]);
  return (
    <ModalTemplate
      close={close}
      header="Upload Preview Audio"
      twoButtons
      confirmText="Save"
      cancelText="Cancel"
      disableConfirm={disableConfirm}
      confirm={() => {
        if (!audio) {
          return;
        }
        if (editData && saveEdit) {
          saveEdit({ name, url, audio });
        } else {
          save({ name, url, audio });
        }

        setName("");
        setUrl("");
        setAudio(undefined);
      }}
    >
      <TextInput
        label="Track Title"
        placeholder="Enter Track Title"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <Gap />
      {/* <TextInput
        label="URL"
        placeholder="https://"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
      />
      <Gap /> */}
      <Typography weight="semibold" color={Colors.grey400} mb="0.8rem">
        Audio File
      </Typography>
      <ImageContainer>
        {!audio ? (
          <DragNDrop
            type="audio"
            setFile={(file) => setAudio(file)}
            limit={200}
          />
        ) : (
          <>
            <CancelIcon onClick={() => setAudio(undefined)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 12 12"
                fill="none"
              >
                <circle cx="6.00014" cy="5.9999" r="2.57143" fill="#1E1E1E" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.001 6C11.001 8.7614 8.76238 11 6.00098 11C3.23955 11 1.00098 8.7614 1.00098 6C1.00098 3.23857 3.23955 1 6.00098 1C8.76238 1 11.001 3.23857 11.001 6ZM4.48579 4.48483C4.63224 4.33838 4.86967 4.33838 5.01613 4.48483L6.00098 5.46965L6.98578 4.48484C7.13223 4.33839 7.36968 4.33839 7.51613 4.48484C7.66258 4.63128 7.66258 4.86872 7.51613 5.01515L6.53128 6L7.51613 6.9848C7.66258 7.13125 7.66258 7.3687 7.51613 7.51515C7.36968 7.6616 7.13223 7.6616 6.98578 7.51515L6.00098 6.53035L5.01613 7.51515C4.86969 7.6616 4.63225 7.6616 4.4858 7.51515C4.33936 7.3687 4.33936 7.13125 4.4858 6.98485L5.47063 6L4.48579 5.01515C4.33934 4.86871 4.33934 4.63127 4.48579 4.48483Z"
                  fill="#CDCDCD"
                />
              </svg>
            </CancelIcon>
            <UploadedContainer>
              <Typography size="xs" weight="semibold">
                {audio.name}
              </Typography>
            </UploadedContainer>
          </>
        )}
      </ImageContainer>
      <Typography size="xs" color={Colors.grey400} ml="1" align="center">
        .mp3, .wav, .aac, .flac file
      </Typography>
    </ModalTemplate>
  );
};

export default EmbedAudioModal;

const Gap = styled.div`
  height: 1.6rem;
  width: 40rem;
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 10rem;
  margin-bottom: 0.8rem;
  position: relative;
`;

const UploadedContainer = styled.div`
  object-fit: contain;
  width: 100%;
  height: 100%;
  border-radius: 0.8rem;
  background-color: ${Colors.grey600};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.white100};
`;

const CancelIcon = styled.div`
  position: absolute;
  width: 1.4rem;
  height: 1.4rem;
  top: -0.7rem;
  right: -0.7rem;
  cursor: pointer;
`;
